import appSettings from '@/app-settings.json';
import { StrOracleApiSender } from './stroracle-api-sender';

// This class sends non-city-based requests to stroracle api
export class StrOracleDefaultApiSender extends StrOracleApiSender {
  baseDomain = `${this.dataDomain}/default/stroracle`;

  dataDomain = this.baseDomain;

  // eslint-disable-next-line class-methods-use-this
  getDataDomain() {
    return `${appSettings.apiDomain}`;
  }

  async get(path, queryParams, responseType = 'json', otherParams = {}) {
    const queryParamsAndMode = { ...this.mode, ...queryParams };

    const escapedUrl = this.generateEscapedUri(path);
    return this.axiosInstance.get(escapedUrl, {
      params: queryParamsAndMode,
      responseType,
      ...otherParams,
    });
  }

  async getWithToken(
    path,
    queryParams,
    responseType = 'json',
    otherParams = {}
  ) {
    const queryParamsAndMode = { ...this.mode, ...queryParams };

    await this.setToken();

    const escapedUrl = this.generateEscapedUri(path);
    return this.axiosInstance.get(escapedUrl, {
      params: queryParamsAndMode,
      responseType,
      ...otherParams,
    });
  }
}

export const strOracleDefaultApiSender = new StrOracleDefaultApiSender();
